import { DB_CHART_CONFIG } from '@/utils/const/products/vod-assessment';
import LineChart from '../../echars/LineChart';
import Styles from './index.module.scss';
interface IChartPointItem {
  bitRate: number;
  KVQ: number;
}

interface IProps {
  data: {
    zzql: IChartPointItem[];
    common: IChartPointItem[];
  };
}

const BDRateChart = ({ data }: IProps) => {
  return (
    <div>
      <div className={Styles.bdRateTitle}>
        <div>
          {DB_CHART_CONFIG.label[0]}
          <span className={Styles.textTarget}>{DB_CHART_CONFIG.label[1]}</span>
          {DB_CHART_CONFIG.label[2]}
          <span className={Styles.textCommon}>{DB_CHART_CONFIG.label[3]}</span>
          {DB_CHART_CONFIG.label[4]}
        </div>
        {/* <div className={Styles.chartTitle}>
          BD-Rate
          <InfoTooltip title="BD-rate是评价视频编码算法性能的主要参数之一，表示新算法编码的视频相对于原来的算法在码率和客观指标分数上的变化情况。在视频编码中，码率低表示压缩量大，客观指标分数高表示客观质量好。因此，对于一种编码算法，如果压缩视频码率降低、客观指标分数提高，那么该算法具有良好的性能。但是通常视频编码算法在提高压缩量的同时会损失压缩质量，即码率减小的同时客观指标分数也减小，此时就需要使用BD-rate进行衡量。" />
        </div> */}
      </div>
      <LineChart
        data={data}
        xAxisField="bitRate"
        xAxisName={DB_CHART_CONFIG.xAxisName}
        yAxisField="KVQ"
        yAxisName="KVQ"
        yAxisScale={true}
        grid={{ right: 74 }}
        series={[
          { name: DB_CHART_CONFIG.series.common, key: 'common' },
          { name: DB_CHART_CONFIG.series.zzql, key: 'zzql' },
        ]}
        style={{ width: 516, height: 260 }}
        tooltipFormatter={(params) => {
          let res = `<div><div>` + params[0].axisValue + ' kbps' + `</div>`;
          params.forEach((item) => {
            res +=
              '<div>' +
              item.marker +
              item.seriesName +
              `&nbsp;` +
              `<span>` +
              item.value[1] +
              `</span></div>`;
          });
          return res + `</div>`;
        }}
      />
    </div>
  );
};

export default BDRateChart;
